import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Loader from "../../../../loader/Loader";
import AxiosController from "../../../../authentication/AxiosController";
import { Button, Card, Table } from "react-bootstrap";
import { Tabs } from "@mantine/core";
import { Chart } from "primereact/chart";
import DateRangePickerComponent from "../../../../date/DateRangePickerComponent";
import { addDays, format } from "date-fns";

const SellerReports = () => {
  const { slug, lang } = useParams();
  const [_] = useTranslation("global");
  const box_head_dir = lang === "en" ? "ltr" : "rtl";
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);
  const [allData, setAllData] = useState({});
  const [sellerId, setSellerId] = useState("");
  const [dateRange, setDateRange] = useState({
    selection: {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  });
  const [appliedStartDate, setAppliedStartDate] = useState(dateRange.selection.startDate);
  const [appliedEndDate, setAppliedEndDate] = useState(dateRange.selection.endDate);

  const handleApplyDateRange = (start, end) => {
    const formattedStartDate = new Date(start.setHours(0, 0, 0, 0));
    const formattedEndDate = new Date(end.setHours(0, 0, 0, 0));
    setAppliedStartDate(formattedStartDate);
    setAppliedEndDate(formattedEndDate);
  };

  const get_seller_reports = () => {
    setLoading(true);
    AxiosController.get(
      `/apiv2/${slug}/${lang}/sellers-reports/seller/${sellerId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          start_date: appliedStartDate ? format(appliedStartDate, "yyyy-MM-dd") : undefined,
          end_date: appliedEndDate ? format(appliedEndDate, "yyyy-MM-dd") : undefined,
        },
      }
    )
      .then((res) => {
        setLoading(false);
        setAllData(res?.data || {});
      })
      .catch(() => {
        setLoading(false);
        setAllData({});
      });
  };
  const [orders, setOrders] = useState([]);

  const get_order_by_day_report = () => {
    setLoading(true);
    AxiosController.get(`/api/${slug}/${lang}/reports/orders-by-days`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        seller_id: sellerId,
        start_date: appliedStartDate ? format(appliedStartDate, "yyyy-MM-dd") : undefined,
        end_date: appliedEndDate ? format(appliedEndDate, "yyyy-MM-dd") : undefined,
      },
    })
      .then((res) => {
        setLoading(false);
        setOrders(res.data || []);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const chartData = {
    labels: orders.map((order) => order.day),
    datasets: [
      {
        label: _("panel.shipped_orders"),
        data: orders.map((order) => order.shipped_count),
        backgroundColor: "rgba(89, 198, 201, 0.6)",
        borderColor: "rgba(89, 198, 201, 1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: _("panel.shipped_orders"),
      },
    },
  };

  return (
    <div className="flex-grow-1 stats-component" dir={box_head_dir}>
      <div className="reports-container my-3 d-flex flex-column gap-2 px-2 position-relative">
        <Loader active={loading} />

        <div className="d-flex flex-column flex-lg-row gap-3 align-items-stretch align-items-lg-center w-100">
          <input
            type="text"
            className="form-control w-100"
            placeholder={_("panel.theseller")}
            onChange={(e) => setSellerId(e.target.value)}
          />
          <DateRangePickerComponent
            state={dateRange}
            setState={setDateRange}
            applyDateRange={handleApplyDateRange}
            width="100%"
          /> 
          <Button
            className="fs-5 px-5 w-100 w--auto"
            style={{
              backgroundColor: "rgb(89, 198, 201)",
              border: "none",
              borderRadius: "7px",
            }}
            onClick={() => {
              get_seller_reports();
              get_order_by_day_report();
            }}
          >
            {_("panel.search")}
          </Button>
        </div>
        <div className="row m-1 pb-3">
          <Card className="p-3">
            <div className="row g-0">
              <div className="col-lg-4">
                <Card.Img
                  src={
                    allData?.user?.photo ||
                    "https://res.cloudinary.com/ecombo-network/image/upload/f_auto/v1637605387/Ecombo/blank-image_yr3ead.jpg"
                  }
                  alt="user? Photo"
                  className="img-fluid rounded-start"
                  style={{ objectFit: "cover", height: "100%" }}
                />
              </div>
              <div className="col-lg-8 gy-4">
                <Card.Body>
                  <Card.Title className="fw-bold fs-4 mt-2 mb-2">
                    {allData?.user?.first_name} {allData?.user?.last_name}
                  </Card.Title>
                  <Card.Subtitle className="mb-2 mt-2 text-muted">
                    {allData?.user?.email}
                  </Card.Subtitle>
                  <Card.Text className=" d-flex flex-column">
                    <div>
                      <strong>{_("panel.Telephone")} : </strong>
                      {allData?.user?.phone_number}
                    </div>
                    <br />
                    <div>
                      <strong>{_("panel.birth")} :</strong>
                      {allData?.user?.birthdate
                        ? new Date(
                            allData?.user?.birthdate
                          ).toLocaleDateString()
                        : "N/A"}
                    </div>
                    <br />
                    <div>
                      <strong>{_("panel.heardAboutUs")} : </strong>
                      {allData?.user?.heard_about_us
                        ? allData?.user?.heard_about_us === "other"
                          ? `${_("registeration.heardAboutUsOptions.other")}: ${
                              allData?.user?.heard_about_us_other
                            }`
                          : _(
                              `registeration.heardAboutUsOptions.${allData?.user?.heard_about_us}`
                            )
                        : "N/A"}
                    </div>
                    <br />
                    <div>
                      <strong>{_("panel.joinedCommunity")} : </strong>
                      {allData?.user?.join_community
                        ? _("panel.yes")
                        : _("panel.no")}
                    </div>
                    <br />
                    <div>
                      <strong>{_("panel.country")} : </strong>
                      {allData?.user?.country || "N/A"}
                    </div>
                    <br />
                    <div>
                      <strong>{_("panel.status")} : </strong>
                      {allData?.user?.is_active ? "Active" : "Inactive"}
                    </div>
                    <br />
                    <div>
                      <strong>{_("panel.lastLogin")} :</strong>
                      {allData?.user?.last_login
                        ? new Date(allData?.user?.last_login).toLocaleString()
                        : "N/A"}
                    </div>
                  </Card.Text>
                  <Button
                    className="mt-2 mb-2"
                    variant="primary"
                    href={allData?.user?.fb_link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {_("panel.facebook")}
                  </Button>
                </Card.Body>
              </div>
            </div>
          </Card>
        </div>
        <Tabs defaultValue="products" className="w-100">
          <Tabs.List>
            <Tabs.Tab
              value="products"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.products")}
            </Tabs.Tab>
            <Tabs.Tab value="cities" className="fs-5" color="rgb(89, 198, 201)">
              {_("home.cities")}
            </Tabs.Tab>

            <Tabs.Tab
              value="statusDetails"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.statusDetails")}
            </Tabs.Tab>
            <Tabs.Tab
              value="orderByDay"
              className="fs-5"
              color="rgb(89, 198, 201)"
            >
              {_("panel.orderByDay")}
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="products">
            <div style={{ position: "relative", overflowX: "auto" }}>
              <Table
                responsive
                dir={box_head_dir}
                className="reports-table text-nowrap text-center"
              >
                <thead>
                  <tr className="text-center">
                    <th>{_("panel.productTitle")}</th>
                    <th>{_("panel.totalorders")}</th>
                    <th>{_("panel.deliveredOrders")}</th>
                    <th>{_("panel.canceledOrders")}</th>
                    <th>{_("panel.seller_commission")}</th>
                    <th>{_("panel.sys_commission")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allData &&
                    allData.ordersDetails_products &&
                    allData.ordersDetails_products
                      .sort((a, b) => b.orders_number - a.orders_number)
                      .map((product) => (
                        <tr key={product.product_id}>
                          <td>
                            <span className="fw-bold">
                              {" "}
                              {product.product_id} #
                            </span>
                            <br />
                            {product.product.title}
                          </td>
                          <td>
                            {Number(product.orders_number).toLocaleString()}
                          </td>
                          <td>
                            {Number(product.delivered_count).toLocaleString()}{" "}
                            <br />
                            {(
                              (Number(product.delivered_count) /
                                Number(product.orders_number)) *
                              100
                            ).toFixed(2)}
                            %
                          </td>
                          <td>
                            {Number(product?.canceled_count).toLocaleString()}
                            <br />
                            {(
                              (Number(product?.canceled_count) /
                                Number(product?.orders_number)) *
                              100
                            ).toFixed(2)}
                            %
                          </td>
                          <td>
                            {Number(
                              product.seller_commission
                            ).toLocaleString()}
                          </td>
                          <td>
                            {Number(product.sys_commission).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </Table>
            </div>
          </Tabs.Panel>
          <Tabs.Panel value="cities">
            <div style={{ position: "relative", overflowX: "auto" }}>
              <Table
                responsive
                dir={box_head_dir}
                className="reports-table text-nowrap text-center"
              >
                <thead>
                  <tr className="text-center">
                    <th>{_("home.provinces")}</th>
                    <th>{_("panel.totalorders")}</th>
                    <th>{_("panel.deliveredOrders")}</th>
                    <th>{_("panel.canceledOrders")}</th>
                    <th>{_("panel.seller_commission")}</th>
                    <th>{_("panel.sys_commission")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allData &&
                    allData.orders_govs &&
                    allData.orders_govs
                      .sort(
                        (a, b) =>
                          Number(b.total_orders) - Number(a.total_orders)
                      )
                      .map((gov) => (
                        <tr key={gov.gov_id}>
                          <td>
                            <span className="fw-bold"> # {gov.gov_id}</span>{" "}
                            <br />
                            {gov.government.arabic_name}
                          </td>
                          <td>{Number(gov.total_orders).toLocaleString()}</td>
                          <td>
                            {Number(gov.delivered_count).toLocaleString()}{" "}
                            <br />
                            {(
                              (Number(gov.delivered_count) /
                                Number(gov.total_orders)) *
                              100
                            ).toFixed(2)}
                            %
                          </td>
                          <td> 
                            {Number(gov.cancel_count).toLocaleString()}
                            <br />
                            {(
                              (Number(gov.cancel_count) /
                                Number(gov.total_orders)) *
                              100
                            ).toFixed(2)}
                            %
                          </td>
                          <td>
                            {Number(gov.seller_commission).toLocaleString()}
                          </td>
                          <td>{Number(gov.sys_commission).toLocaleString()}</td>
                        </tr>
                      ))}
                </tbody>
              </Table>
            </div>
          </Tabs.Panel>
          <Tabs.Panel value="statusDetails">
            <div style={{ position: "relative", overflowX: "auto" }}>
              <Table
                responsive
                dir={box_head_dir}
                className="reports-table text-nowrap text-center"
              >
                {" "}
                <thead>
                  <tr className="text-center">
                    <th>{_("panel.status")}</th>
                    <th>{_("home.productsNumber")}</th>
                  </tr>
                </thead>
                <tbody>
                  {allData &&
                    allData.orders_status &&
                    allData.orders_status
                      .sort(
                        (a, b) =>
                          Number(b.total_orders) - Number(a.total_orders)
                      )
                      .map((status) => (
                        <tr key={status.status}>
                          <td>{_(`panel.${status.status}`)}</td>
                          <td>
                            {Number(status?.total_orders).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                </tbody>
              </Table>
            </div>
          </Tabs.Panel>
          <Tabs.Panel value="orderByDay">
            <div className="row">
              <Chart
                type="bar"
                data={chartData}
                options={options}
                style={{ width: "100%" }}
              />
            </div>
          </Tabs.Panel>
        </Tabs>
      </div>
    </div>
  );
};

export default SellerReports;
